import React from "react";
import PropTypes from "prop-types";
import styles from "./ShapeButton.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faPlusSquare } from "@fortawesome/free-solid-svg-icons";

/**
 * Interactive component. A button with a shape icon.
 */
export function ShapeButton({ shape, onClick }) {
  return (
    <>
      {shape === "round" ? (
        <>
          <FontAwesomeIcon
            icon={faTimesCircle}
            className={styles.icon}
            onClick={onClick}
          />
        </>
      ) : (
        <>
          <FontAwesomeIcon
            icon={faPlusSquare}
            className={styles.icon}
            onClick={onClick}
          />
        </>
      )}
    </>
  );
}

ShapeButton.propTypes = {
  /**
   * String that determines the shape and icon of the button.
   */
  shape: PropTypes.oneOf(["round", "square"]),
  /**
   * Function that fires when the button is clicked.
   */
  onClick: PropTypes.func,
};
